import { combineReducers } from '@reduxjs/toolkit';
import authenticatePinReducer from 'store/billing/Payment/reducers/authenticate';
import PaymentInfoReducer from 'store/billing/Payment/reducers/paymentInfo';
import ApplyPaymentReducer from 'store/billing/Payment/reducers/applypayment';

export default combineReducers({
  authenticatePin: authenticatePinReducer,
  paymentInfo: PaymentInfoReducer,
  applyPayment: ApplyPaymentReducer
});
